import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  loading?: boolean;
  className?: string;
}

export function Pagination({
  page,
  totalPages,
  onPageChange,
  loading = false,
  className = '',
}: PaginationProps) {
  if (totalPages < 1) return null;

  const navButton =
    'rounded-lg border border-line bg-canvas px-3 py-1.5 text-[11px] font-bold text-ink-muted transition-colors hover:border-accent hover:text-ink disabled:cursor-not-allowed disabled:opacity-40';

  return (
    <div
      className={`border-line bg-canvas-raised flex items-center justify-between border-t px-5 py-3 ${className}`}
    >
      <span className="text-ink-dim text-[12px]">
        Trang <strong className="text-ink">{page}</strong> / {totalPages}
      </span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => {
            onPageChange(page - 1);
          }}
          disabled={page <= 1 || loading}
          className={navButton}
          aria-label="Trang trước"
        >
          <ChevronLeft size={14} />
        </button>
        <button
          type="button"
          onClick={() => {
            onPageChange(page + 1);
          }}
          disabled={page >= totalPages || loading}
          className={navButton}
          aria-label="Trang sau"
        >
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
